module.exports = __webpack_public_path__ + "img/surveying2_table.ef659a79.png";